module.exports = __webpack_public_path__ + "static/img/login_background.69e5422c.png";